"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const art_layout_names_1 = __importDefault(require("./art-layout-names"));
const art_sets_backgrounds_1 = __importDefault(require("./art-sets-backgrounds"));
const tiles_1 = require("../tiles");
const threeLayouts = [
    {
        id: art_layout_names_1.default.TRIO_PORTRAIT,
        displayName: 'Trio',
        displayLayoutIndex: 2,
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.GREY_COUCH_ZOOMED,
                tiles: [
                    {
                        id: 'couch_190cm_3_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.30560420315236425,
                            y: 0.2583187390542907,
                            width: 0.11208406304728546,
                            height: 0.14798598949211908
                        }
                    },
                    {
                        id: 'couch_190cm_3_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.44395796847635727,
                            y: 0.2583187390542907,
                            width: 0.11208406304728546,
                            height: 0.14798598949211908
                        }
                    },
                    {
                        id: 'couch_190cm_3_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5823117338003503,
                            y: 0.2583187390542907,
                            width: 0.11208406304728546,
                            height: 0.14798598949211908
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.GREY_COUCH_ZOOMED,
                tiles: [
                    {
                        id: 'couch_190cm_3_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.22504378283712784,
                            y: 0.19527145359019266,
                            width: 0.16549912434325745,
                            height: 0.21891418563922943
                        }
                    },
                    {
                        id: 'couch_190cm_3_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.4168126094570928,
                            y: 0.19527145359019266,
                            width: 0.16549912434325745,
                            height: 0.21891418563922943
                        }
                    },
                    {
                        id: 'couch_190cm_3_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6085814360770578,
                            y: 0.19527145359019266,
                            width: 0.16549912434325745,
                            height: 0.21891418563922943
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.GREY_COUCH_ZOOMED,
                tiles: [
                    {
                        id: 'couch_190cm_3_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.08231173380035026,
                            y: 0.12171628721541156,
                            width: 0.2609457092819615,
                            height: 0.3607705779334501
                        }
                    },
                    {
                        id: 'couch_190cm_3_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.36952714535901926,
                            y: 0.12171628721541156,
                            width: 0.2609457092819615,
                            height: 0.3607705779334501
                        }
                    },
                    {
                        id: 'couch_190cm_3_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.6567425569176882,
                            y: 0.12171628721541156,
                            width: 0.2609457092819615,
                            height: 0.3607705779334501
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.GREY_COUCH_BLANKET,
                tiles: [
                    {
                        id: 'couch_3_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_27X36,
                        normalizedFrame: {
                            x: 0.37482415090006016,
                            y: 0.16637478108581435,
                            width: 0.24976314202865266,
                            height: 0.3336252189141856
                        }
                    },
                    {
                        id: 'couch_3_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_27X36,
                        normalizedFrame: {
                            x: 0.10683012259194395,
                            y: 0.16637478108581435,
                            width: 0.24976314202865266,
                            height: 0.3336252189141856
                        }
                    },
                    {
                        id: 'couch_3_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_27X36,
                        normalizedFrame: {
                            x: 0.6428181792081769,
                            y: 0.16637478108581435,
                            width: 0.24976314202865274,
                            height: 0.3336252189141856
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.TRIO_LANDSCAPE,
        displayName: 'Trio',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.ARMCHAIR,
                tiles: [
                    {
                        id: 'scene_couch_wall_3_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_11X8,
                        normalizedFrame: {
                            x: 0.3012259194395809,
                            y: 0.1295971978984238,
                            width: 0.15148861646234676,
                            height: 0.11471103327495621
                        }
                    },
                    {
                        id: 'scene_couch_wall_3_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_11X8,
                        normalizedFrame: {
                            x: 0.3012259194395809,
                            y: 0.26970227670753066,
                            width: 0.15148861646234676,
                            height: 0.11471103327495621
                        }
                    },
                    {
                        id: 'scene_couch_wall_3_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_11X8,
                        normalizedFrame: {
                            x: 0.47723292469352135,
                            y: 0.1987740805604203,
                            width: 0.15148861646234676,
                            height: 0.11471103327495621
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.ARMCHAIR,
                tiles: [
                    {
                        id: 'scene_couch_wall_3_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_16X12,
                        normalizedFrame: {
                            x: 0.1987740805604203,
                            y: 0.1637478108581436,
                            width: 0.23555166374781086,
                            height: 0.1777583187390543
                        }
                    },
                    {
                        id: 'scene_couch_wall_3_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_16X12,
                        normalizedFrame: {
                            x: 0.1987740805604203,
                            y: 0.36427320490367776,
                            width: 0.23555166374781086,
                            height: 0.1777583187390543
                        }
                    },
                    {
                        id: 'scene_couch_wall_3_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_16X12,
                        normalizedFrame: {
                            x: 0.45709281961471104,
                            y: 0.2530647985989492,
                            width: 0.23555166374781086,
                            height: 0.1777583187390543
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.ARMCHAIR,
                tiles: [
                    {
                        id: 'scene_couch_wall_3_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_27X20,
                        normalizedFrame: {
                            x: 0.09369527145359138,
                            y: 0.07968476357267872,
                            width: 0.3975481611208406,
                            height: 0.29422066549912435
                        }
                    },
                    {
                        id: 'scene_couch_wall_3_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_27X20,
                        normalizedFrame: {
                            x: 0.09369527145359019,
                            y: 0.3975481611208406,
                            width: 0.3975481611208406,
                            height: 0.29422066549912435
                        }
                    },
                    {
                        id: 'scene_couch_wall_3_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_27X20,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.2504378283712785,
                            width: 0.3975481611208406,
                            height: 0.29422066549912435
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.TRIO_SQUARE,
        displayName: 'Trio',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.GREY_COUCH_ZOOMED,
                tiles: [
                    {
                        id: 'square_8x8_3_1',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.44395796847635727,
                            y: 0.2583187390542907,
                            width: 0.11208406304728546,
                            height: 0.11208406304728546
                        }
                    },
                    {
                        id: 'square_8x8_3_2',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.30560420315236425,
                            y: 0.2583187390542907,
                            width: 0.11208406304728546,
                            height: 0.11208406304728546
                        }
                    },
                    {
                        id: 'square_8x8_3_3',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.5823117338003503,
                            y: 0.2583187390542907,
                            width: 0.11208406304728546,
                            height: 0.11208406304728546
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.GREY_COUCH_ZOOMED,
                tiles: [
                    {
                        id: 'square_12x12_3_1',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.4168126094570928,
                            y: 0.2119089316987741,
                            width: 0.16549912434325745,
                            height: 0.16549912434325745
                        }
                    },
                    {
                        id: 'square_12x12_3_2',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.22504378283712784,
                            y: 0.2119089316987741,
                            width: 0.16549912434325745,
                            height: 0.16549912434325745
                        }
                    },
                    {
                        id: 'square_12x12_3_3',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.6085814360770578,
                            y: 0.2119089316987741,
                            width: 0.16549912434325745,
                            height: 0.16549912434325745
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.GREY_COUCH_ZOOMED,
                tiles: [
                    {
                        id: 'couch 190cm_3_1',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.08231173380035026,
                            y: 0.1584938704028021,
                            width: 0.2609457092819615,
                            height: 0.2609457092819615
                        }
                    },
                    {
                        id: 'couch 190cm_3_2',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.36952714535901926,
                            y: 0.1584938704028021,
                            width: 0.2609457092819615,
                            height: 0.2609457092819615
                        }
                    },
                    {
                        id: 'couch 190cm_3_3',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.6567425569176882,
                            y: 0.1584938704028021,
                            width: 0.2609457092819615,
                            height: 0.2609457092819615
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.THREE_TOWER,
        displayName: 'Tower',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.HALL_LAYOUTS,
                tiles: [
                    {
                        id: 'plain_wall_3_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.46234676007005254,
                            y: 0.17075306479859895,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_3_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.46234676007005254,
                            y: 0.28633975481611207,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_3_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.46234676007005254,
                            y: 0.4019264448336252,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.HALL_LAYOUTS,
                tiles: [
                    {
                        id: 'plain_wall_3_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.4448336252189142,
                            y: 0.13922942206654992,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_3_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.4448336252189142,
                            y: 0.30297723292469353,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_3_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.4448336252189142,
                            y: 0.46672504378283713,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.HALL_LAYOUTS,
                tiles: [
                    {
                        id: 'plain_wall_3_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.4133099824868651,
                            y: 0.05253940455341506,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain_wall_3_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.4133099824868651,
                            y: 0.30998248686514884,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain_wall_3_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.4133099824868651,
                            y: 0.5674255691768827,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.THREE_ORGANIC,
        displayName: 'Organic',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'door_3_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5796847635726795,
                            y: 0.318739054290718,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'door_3_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.6471103327495622,
                            y: 0.17425569176882663,
                            width: 0.09369527145359019,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'door_3_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6943957968476357,
                            y: 0.318739054290718,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'door_3_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5148861646234676,
                            y: 0.3126094570928196,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'door_3_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6304728546409807,
                            y: 0.1085814360770578,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'door_3_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.6742556917688266,
                            y: 0.3126094570928196,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.THREE_VERTICAL,
        displayName: 'Vertical',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'door_3_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.563922942206655,
                            y: 0.17425569176882663,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'door_3_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.6085814360770578,
                            y: 0.37828371278458844,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'door_3_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.723292469352014,
                            y: 0.26532399299474607,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'door_3_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.47373029772329245,
                            y: 0.1436077057793345,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    },
                    {
                        id: 'door_3_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5586690017513135,
                            y: 0.4658493870402802,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'door_3_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.7180385288966725,
                            y: 0.29422066549912435,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.THREE_STAIRWAY,
        displayName: 'Stairway',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.STAIRWAY_LAYOUTS,
                tiles: [
                    {
                        id: 'stairway_3_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.36339754816112085,
                            y: 0.27583187390542907,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_3_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.46059544658493873,
                            y: 0.22329246935201402,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_3_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5577933450087565,
                            y: 0.17162872154115585,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.STAIRWAY_LAYOUTS,
                tiles: [
                    {
                        id: 'stairway_3_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.3073555166374781,
                            y: 0.2609457092819615,
                            width: 0.11646234676007006,
                            height: 0.15499124343257442
                        }
                    },
                    {
                        id: 'stairway_3_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.4413309982486865,
                            y: 0.18388791593695272,
                            width: 0.11646234676007006,
                            height: 0.15499124343257442
                        }
                    },
                    {
                        id: 'stairway_3_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5753064798598949,
                            y: 0.10595446584938704,
                            width: 0.11646234676007006,
                            height: 0.15499124343257442
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.STAIRWAY_LAYOUTS,
                tiles: [
                    {
                        id: 'stairway_3_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.20928196147110334,
                            y: 0.31436077057793343,
                            width: 0.18213660245183888,
                            height: 0.2521891418563923
                        }
                    },
                    {
                        id: 'stairway_3_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.4089316987740806,
                            y: 0.18826619964973731,
                            width: 0.18213660245183888,
                            height: 0.2521891418563923
                        }
                    },
                    {
                        id: 'stairway_3_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.6085814360770578,
                            y: 0.06217162872154115,
                            width: 0.18213660245183888,
                            height: 0.2521891418563923
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.THREE_BLOCKS,
        displayName: 'Blocks',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'stairway_3_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5726795096322241,
                            y: 0.2031523642732049,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'stairway_3_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5726795096322241,
                            y: 0.3476357267950963,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'stairway_3_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.6873905429071804,
                            y: 0.27495621716287216,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'stairway_3_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5306479859894921,
                            y: 0.18826619964973731,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'stairway_3_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5306479859894921,
                            y: 0.3922942206654991,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'stairway_3_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6900175131348512,
                            y: 0.28984238178633975,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'stairway_3_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.4316987740805604,
                            y: 0.06042031523642732,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    },
                    {
                        id: 'stairway_3_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.4316987740805604,
                            y: 0.38266199649737304,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    },
                    {
                        id: 'stairway_3_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.6760070052539404,
                            y: 0.22154115586690018,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.THREE_MOLECULAR,
        displayName: 'Molecular',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DESK_LAYOUTS,
                tiles: [
                    {
                        id: 'desk_3_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.20577933450087565,
                            y: 0.29597197898423816,
                            width: 0.14886164623467601,
                            height: 0.19702276707530647
                        }
                    },
                    {
                        id: 'desk_3_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.38966725043782835,
                            y: 0.2486865148861646,
                            width: 0.22066549912434325,
                            height: 0.29246935201401053
                        }
                    },
                    {
                        id: 'desk_3_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.6453590192644484,
                            y: 0.29597197898423816,
                            width: 0.14886164623467601,
                            height: 0.19702276707530647
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DESK_LAYOUTS,
                tiles: [
                    {
                        id: 'desk_3_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.07005253940455342,
                            y: 0.2486865148861646,
                            width: 0.22066549912434325,
                            height: 0.29246935201401053
                        }
                    },
                    {
                        id: 'desk_3_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.3257443082311734,
                            y: 0.15411558669001751,
                            width: 0.3476357267950963,
                            height: 0.4807355516637478
                        }
                    },
                    {
                        id: 'desk_3_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.7084063047285464,
                            y: 0.2486865148861646,
                            width: 0.22066549912434325,
                            height: 0.29246935201401053
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.THREE_CLOUD,
        displayName: 'Cloud',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.BENCH_LAYOUTS,
                tiles: [
                    {
                        id: 'bench_3_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.27408056042031526,
                            y: 0.2565674255691769,
                            width: 0.16549912434325745,
                            height: 0.21891418563922943
                        }
                    },
                    {
                        id: 'bench_3_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.3274956217162872,
                            y: 0.08231173380035026,
                            width: 0.11208406304728546,
                            height: 0.14798598949211908
                        }
                    },
                    {
                        id: 'bench_3_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.4658493870402802,
                            y: 0.18563922942206654,
                            width: 0.2609457092819615,
                            height: 0.3607705779334501
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.THREE_SPARSE,
        displayName: 'Sparse',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'door_3_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5052539404553416,
                            y: 0.22854640980735552,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'door_3_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.6952714535901926,
                            y: 0.17075306479859895,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'door_3_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.6952714535901926,
                            y: 0.3458844133099825,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'door_3_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5,
                            y: 0.3064798598949212,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'door_3_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.6900175131348512,
                            y: 0.2224168126094571,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'door_3_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6900175131348512,
                            y: 0.3975481611208406,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'door_3_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.46059544658493873,
                            y: 0.2530647985989492,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    },
                    {
                        id: 'door_3_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.7355516637478109,
                            y: 0.22416812609457093,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'door_3_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.7355516637478109,
                            y: 0.4001751313485114,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    }
                ]
            }
        ]
    }
];
exports.default = threeLayouts;
//# sourceMappingURL=three.js.map